import React from "react";
import AllPlans from "../../components/templates/Plans/AllPlans/AllPlans";

const PlansPage = (props) => {
    return (
        <>
            <AllPlans {...props} />
        </>
    );
};

export async function getStaticProps() {
    const fs = require("fs");
    let { fetchBuildingPlans } = require("../../utils/fetchBuildData");
    let { generatePlansRssFeed } = require("../../utils/generatePlansRssFeed");
    const plans = await fetchBuildingPlans();

    // rss
    if (plans.length > 0) {
        const rss = generatePlansRssFeed(plans);
        fs.writeFileSync("./public/plans.xml", rss);
    }

    return {
        props: {
            plans,
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}

export default PlansPage;
